<template>
  <v-app id="register">
    <v-container fluid fill-height back-ground>
      <v-layout align-center justify-center>
        <v-flex lg4 md6 sm8 xs12>
          <v-card color="rgb(255, 255, 255, 1)" class="radius">
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg12 md8 xs12 mt-3 px-3 text-xs-center>
                  <img
                    src="/static/logo/coconutlogo.png"
                    width="300"
                    height="150"
                    class="hidden-xs-only"
                  />
                  <img
                    src="/static/logo/coconutlogo.png"
                    width="300"
                    height="150"
                    class="hidden-sm-and-up"
                  />
                </v-flex>
                <v-flex lg12 md8 xs12 mt-3 px-3>
                  <v-form v-model="form_valid">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>{{$t('register')}}</h2>
                      </v-flex>

                      <v-flex xs12>
                        <v-text-field
                          :label="$t('email')"
                          append-icon="email"
                          v-model="form_model.email"
                          required
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          :label="$t('password')"
                          append-icon="vpn_key"
                          v-model="form_model.password"
                          type="password"
                          required
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          :label="$t('confirm_password')"
                          append-icon="vpn_key"
                          v-model="form_model.confirm_password"
                          type="password"
                          required
                        />
                      </v-flex>
                    </v-layout>
                  </v-form>
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs8 style="margin-top:10px;">
                        <router-link to="/login">{{$t('already_account')}}</router-link>
                      </v-flex>
                      <v-flex xs4>
                        <v-btn
                          color="primary"
                          block
                          style="height: 3em;"
                          v-text="$t('register')"
                          @click="sendRegisterinvite()"
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-snackbar
          v-model="snack_model.status"
          :timeout="3500"
          :top="'top'"
          :right="'right'"
          :color="snack_model.type"
        >
          {{ snack_model.msg }}
          <v-btn dark flat icon @click="snack_model.status = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>
        <div class="text-xs-center">
          <v-dialog v-model="dialog_loading" persistent width="260">
            <v-card>
              <v-card-text>
                Please stand by
                <v-progress-linear indeterminate color="red" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </v-layout>
    </v-container>
  </v-app>
</template>
<script>
/* eslint-disable */
import UserService from "@/services/UserService";
export default {
  data: () => ({
    form_valid: false,
    dialog_loading: false,
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    invite_code: "",
    form_model: {
      email: "",
      password: "",
      usercode: "",
      confirm_password: ""
    },
    form_rules: {
      email: [
        v => !!v || "do not empty.",
        v =>
          v.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || "Email format incorrect"
      ],
      password: [v => !!v || "do not empty."]
    }
  }),
  async created() {
    this.invite_code = this.$route.params.token;
  },
  methods: {
    sendRegisterinvite() {
      let vue = this;
      if (this.form_model.email != "") {
        this.form_model.usercode = this.form_model.email;
        if (this.form_model.password == this.form_model.confirm_password) {
          this.dialog_loading = true;
          UserService._registerInvite(this.form_model, this.invite_code)
            .then(res => {
              console.log(res);
              sessionStorage.clear();
              localStorage.clear();

              this.snack_model.status = true;
              this.snack_model.msg = "ลงทะเบียนสำเร็จ";
              this.snack_model.type = "success";
              setTimeout(function() {
                this.dialog_loading = false;
                vue.$router.push("/login");
              }, 2000);
            })
            .catch(err => {
              localStorage._empcode = "";
              this.dialog_loading = false;
              this.snack_model.status = true;
              this.snack_model.msg = "มีผู้ใช้ในระบบแล้ว";
              this.snack_model.type = "error";
              console.log(err);
            });
        } else {
          this.snack_model.status = true;
          this.snack_model.msg = "พาสเวิดไม่ตรงกัน";
          this.snack_model.type = "error";
        }
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาป้อน Email";
        this.snack_model.type = "error";
      }
    }
  }
};
</script>
<style>
.back-ground {
  background: linear-gradient(to bottom right, #3399ff, #00cc66);
  background-size: cover;
}
.radius {
  border-radius: 15px;
}
</style>
<style type="text/css">
@keyframes lds-pacman-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@-webkit-keyframes lds-pacman-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@keyframes lds-pacman-2 {
  0% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@-webkit-keyframes lds-pacman-2 {
  0% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@keyframes lds-pacman-3 {
  0% {
    -webkit-transform: translate(190px, 0);
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(70px, 0);
    transform: translate(70px, 0);
    opacity: 1;
  }
}
@-webkit-keyframes lds-pacman-3 {
  0% {
    -webkit-transform: translate(190px, 0);
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(70px, 0);
    transform: translate(70px, 0);
    opacity: 1;
  }
}
.lds-pacman {
  position: relative;
}
.lds-pacman > div:nth-child(2) div {
  position: absolute;
  top: 40px;
  left: 40px;
  width: 120px;
  height: 60px;
  border-radius: 120px 120px 0 0;
  background: #3be8ce;
  -webkit-animation: lds-pacman-1 0.9s linear infinite;
  animation: lds-pacman-1 0.9s linear infinite;
  -webkit-transform-origin: 60px 60px;
  transform-origin: 60px 60px;
}
.lds-pacman > div:nth-child(2) div:nth-child(2) {
  -webkit-animation: lds-pacman-2 0.9s linear infinite;
  animation: lds-pacman-2 0.9s linear infinite;
}
.lds-pacman > div:nth-child(1) div {
  position: absolute;
  top: 92px;
  left: -8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1ec7ed;
  -webkit-animation: lds-pacman-3 0.9s linear infinite;
  animation: lds-pacman-3 0.9s linear infinite;
}
.lds-pacman > div:nth-child(1) div:nth-child(1) {
  -webkit-animation-delay: -0.603s;
  animation-delay: -0.603s;
}
.lds-pacman > div:nth-child(1) div:nth-child(2) {
  -webkit-animation-delay: -0.297s;
  animation-delay: -0.297s;
}
.lds-pacman > div:nth-child(1) div:nth-child(3) {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
.lds-pacman {
  width: 200px !important;
  height: 200px !important;
  -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
  transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
}
</style>